// PREFIX: MODULE/VIEW
const PREFIX = 'PAYSBILL/REDUX';

// BUSINESS ACTIONS
export const TABIDX = `${PREFIX}/TABIDX`;
export const SEARCHPARAMS = `${PREFIX}/SEARCHPARAMS`;
